import React, { Component } from 'react';
import FetchService from '../../../services/FetchService.js';

export class BuscadorEmpleadoControl extends Component {
    constructor(props) {
        super(props);
        this.state = { busqueda: '' };
          
        this.inputBusqueda_onChange = this.inputBusqueda_onChange.bind(this);
        this.inputBusqueda_onKeyPress = this.inputBusqueda_onKeyPress.bind(this);
        this.buttonBusqueda_onClick = this.buttonBusqueda_onClick.bind(this);
        this.ddlEmpleados_onChange = this.ddlEmpleados_onChange.bind(this);
    }
    inputBusqueda_onChange(event) {
        this.setState({
            busqueda: event.target.value
        }); 
    }
    inputBusqueda_onKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.buscarEmpleadoPorNombre();
        }
    }
    buttonBusqueda_onClick(event) {
        event.preventDefault();
        this.buscarEmpleadoPorNombre();
    }
    ddlEmpleados_onChange(e) {
        var me = this;
        if (this.props.onEmpleadoSeleccionado) {
            this.props.onEmpleadoSeleccionado(e.target.value)
        }
    }
    buscarEmpleadoPorNombre() {
        var me = this;
        var url = 'api/Calendario/BuscarEmpleadosPorNombre?nombre=' + this.state.busqueda;
        FetchService.send(url, 'GET', null, me.buscarEmpleado.bind(me), me.buscarEmpleadoError.bind(me));
        this.setState({
            busqueda: ""
        });
    }
    buscarEmpleado(datos) {
        var me = this;
        this.setState({
            resultados: datos
        }); 
        let id = "-1";
        if (datos) {
            if (datos.length>0) {
                id = datos[0].id;
            }
        }
        if (this.props.onEmpleadoSeleccionado) {
            this.props.onEmpleadoSeleccionado(id)
        }
        this.forceUpdate(); 
    }
    buscarEmpleadoError(err) {
        alert(err);
    }
    renderList() {
        let options=[]
        if (this.state.resultados) {
            for (var i = 0; i < this.state.resultados.length; i++) {
                var item = this.state.resultados[i];
                var label =  item.nombre  + " [" + item.id  + "]"
                options.push(<option value={item.id}>{label}</option>);
            }
        }
        if (options.length==0) { 
            options.push(<option value="-1">No hay coincidencias</option>);
        }
        return <select className="form-control" onChange={this.ddlEmpleados_onChange}>{options}</select>
    }
    render() {
        return (
            <div>
                <div style={{ textAlign: 'left !important' }}>
                    <div class="form-group">
                        <div class="form-row"> 
                            <div class="input-group col-md-12">
                                <input name="Busqueda" type="text" placeholder="Buscar empleado..." className="form-control" autoFocus value={this.state.busqueda} onChange={this.inputBusqueda_onChange} onKeyPress={this.inputBusqueda_onKeyPress} style={{ autoComplete: 'random-string', autoFill: 'off' }} />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" title="Buscar" onClick={this.buttonBusqueda_onClick}>
                                        <span class="glyphicon glyphicon-search" aria-hidden="true"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <br/>
                        <div class="form-row">
                            <div class="col-md-12">
                                {this.renderList()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
